var _style, _g, _defs, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173 175",
    style: {
      enableBackground: "new 0 0 173 175"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.49;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:none;stroke:#565ADD;stroke-dasharray:5;}\r\n\t.st3{clip-path:url(#SVGID_2_);}\r\n\t.st4{fill:#565ADD;}\r\n\t.st5{fill:#F4A82C;}\r\n\t.st6{fill:none;}\r\n\t.st7{fill:none;stroke:#565ADD;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_37443",
    transform: "translate(-1659.559 2555.441)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1659.56, -2555.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_236-2",
    transform: "translate(11 11)",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 75.5,
    cy: 76.5,
    r: 76
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 75.5,
    cy: 76.5,
    r: 75.5
  })))), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 1746.06,
    cy: -2467.94,
    rx: 67.5,
    ry: 68
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#F7F7FC"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1757.9-2491.4c10.65,0,16.03,4.84,16.03,13.13c0,1.98-0.32,3.77-0.95,5.33l14.35,9.48 c2.75-4.09,4.25-9.07,4.25-14.82c0-16.89-12.59-27.33-32.71-27.33h-32.6h-18.17l18.17,14.91v60.41h17.43v-15.63v-39.66 l-7.11-5.83H1757.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1768.83-2467.89c-2.63,1.72-6.27,2.64-10.92,2.64h-2.83v14.2h3.79c9.95,0,18.05-2.56,23.71-7.17 L1768.83-2467.89z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_365",
    transform: "translate(1659.559 -2555.441)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 86.5,
    cy: 86.5,
    r: 86.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 86.5,
    cy: 86.5,
    r: 86
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogo);
export default __webpack_public_path__ + "static/media/iconLogo.8db1ecc0356ab55b035cd30efe63cca5.svg";
export { ForwardRef as ReactComponent };